import axios from 'axios';

axios.defaults.withCredentials = false;

/**
 * @name createRequestOptions
 * @description Helps to create request options
 * @param {optional} headers
 * @param {optional} withCredentials
 */

const createRequestOptions = (headers: Object, withCredentials: boolean) => {
  const options = {};
  if (headers) {
    options.headers = headers;
  }
  if (withCredentials) {
    options.withCredentials = true;
  }
  return options;
};

/**
 * @name getRequest
 * @description Helps to make a get call
 * @param url - URL to make the call
 * @param headers - Optional
 * @param withCredentials - Optional, useful for CORS issue
 */

export const getRequest = (
  url: string,
  headers?: Object,
  withCredentials?: boolean
) => axios.get(url, createRequestOptions(headers, withCredentials));

/**
 * @name postRequest
 * @description Helps to make a post call
 * @param url - URL to make the call
 * @param data - Request payload
 * @param headers - Optional
 * @param withCredentials - Optional, useful for CORS issue
 */

export const postRequest = (
  url: string,
  data: any,
  headers?: Object,
  withCredentials?: boolean
) => axios.post(url, data, createRequestOptions(headers, withCredentials));
